import React, { useEffect, useState } from 'react';
import { scrollToSection, scrollToTop } from '../utils/scroll';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleModalState = (e) => {
      setModalOpen(!!e.detail?.open);
    };
    window.addEventListener('screenModalState', handleModalState);
    return () => window.removeEventListener('screenModalState', handleModalState);
  }, []);

  const handleLogoClick = () => {
    scrollToTop('smooth');
  };

  const handleGetInTouch = () => {
    scrollToSection('contact', { behavior: 'smooth' });
  };

  return (
    <header
      style={{
        opacity: modalOpen ? 0 : 1,
        pointerEvents: modalOpen ? 'none' : undefined,
        visibility: modalOpen ? 'hidden' : 'visible',
        transition: 'opacity 0.2s ease, visibility 0.2s ease'
      }}
      className={`
        fixed
        top-0
        left-0
        right-0
        z-50

        flex
        justify-center

        pointer-events-none

        transition-all
        duration-700
        ease-[cubic-bezier(0.22,1,0.36,1)]

        ${
          isScrolled
            ? 'px-4 pt-3 sm:pt-4'
            : 'px-5 sm:px-8 pt-4 sm:pt-5'
        }
      `}
    >
      <nav
        aria-label="Main Navigation"
        className={`
          pointer-events-auto

          flex
          items-center

          font-cinematic-body

          transition-all
          duration-700
          ease-[cubic-bezier(0.22,1,0.36,1)]

          ${
            isScrolled
              ? `
                justify-between

                w-[min(92vw,390px)]
                sm:w-[min(90vw,470px)]

                h-[54px]
                sm:h-[58px]

                px-2
                sm:px-2.5

                rounded-full

                bg-white/70
                backdrop-blur-2xl
                backdrop-saturate-150

                border
                border-white/70

                shadow-[0_10px_40px_rgba(0,0,0,0.12)]
              `
              : `
                justify-between

                w-full
                max-w-7xl

                h-[58px]

                px-0

                rounded-none

                bg-transparent
                border-transparent
                shadow-none
              `
          }
        `}
      >

        {/* =====================================================
            LOGO
        ====================================================== */}

        <button
          type="button"
          onClick={handleLogoClick}
          aria-label="Go to home"
          className={`
            group

            flex
            items-center
            shrink-0

            rounded-full

            bg-transparent
            border-none

            p-0

            text-left
            outline-none

            cursor-pointer

            transition-all
            duration-500

            hover:scale-[1.02]
            active:scale-95
          `}
        >

          {/* =================================================
              LOGO CIRCLE
          ================================================= */}

          <span
            className={`
              relative

              flex
              items-center
              justify-center

              shrink-0

              rounded-full

              font-display
              font-bold
              leading-none

              overflow-hidden

              transition-all
              duration-700
              ease-[cubic-bezier(0.22,1,0.36,1)]

              ${
                isScrolled
                  ? `
                    w-10
                    h-10

                    text-sm

                    bg-gray-900
                    text-white

                    border
                    border-gray-800

                    shadow-[0_3px_15px_rgba(0,0,0,0.22)]
                  `
                  : `
                    w-8
                    h-8

                    text-xs

                    bg-white/10
                    text-white

                    border
                    border-white/25

                    shadow-[0_2px_10px_rgba(0,0,0,0.10)]
                  `
              }
            `}
          >

            {/* Subtle glass highlight */}
            <span
              className="
                absolute
                inset-0

                rounded-full

                bg-[linear-gradient(135deg,rgba(255,255,255,0.25),transparent_45%,rgba(255,255,255,0.05))]

                pointer-events-none
              "
            />

            {/* L */}
            <span
              className="
                relative
                z-10

                text-white

                drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]

                transition-transform
                duration-500

                group-hover:scale-110
              "
            >
              L
            </span>

          </span>


          {/* =================================================
              NAME
          ================================================= */}

          <span
            className={`
              font-cinematic-heading
              tracking-tight
              whitespace-nowrap

              overflow-hidden

              transition-all
              duration-700
              ease-[cubic-bezier(0.22,1,0.36,1)]

              ${
                isScrolled
                  ? `
                    ml-2.5

                    max-w-[180px]

                    opacity-100
                    translate-x-0

                    text-[17px]
                    sm:text-[19px]

                    text-gray-900
                  `
                  : `
                    ml-2.5

                    max-w-[200px]

                    opacity-100
                    translate-x-0

                    text-[20px]
                    sm:text-[24px]

                    text-white
                  `
              }
            `}
          >
            Lokeswaran M
          </span>

        </button>


        {/* =====================================================
            GET IN TOUCH
        ====================================================== */}

        <button
          type="button"
          onClick={handleGetInTouch}
          className={`
            shrink-0

            whitespace-nowrap

            bg-transparent
            border-none

            outline-none

            cursor-pointer

            font-cinematic-body
            font-medium

            transition-all
            duration-700
            ease-[cubic-bezier(0.22,1,0.36,1)]

            ${
              isScrolled
                ? `
                  mr-1

                  px-4
                  py-2

                  text-[14px]
                  sm:text-[15px]

                  text-gray-900

                  hover:bg-black/5

                  rounded-full
                `
                : `
                  mr-0

                  px-0
                  py-0

                  text-[18px]
                  lg:text-[20px]

                  text-white

                  hover:opacity-60
                `
            }
          `}
        >
          Get in touch
        </button>

      </nav>
    </header>
  );
}